import React from 'react'
import './index.css';
import { MDBBtn } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
const sizes = {
    small: 40,
    medium: 70,
};

const ContainerImagen = ({ url, size = "small", onImageRemove, index }) => (
    <div className='image-container'>
        <img width={sizes[size]} height={sizes[size]} src={url} />
        <div className='icon-remove' onClick={() => onImageRemove(index)}>
            <FontAwesomeIcon icon={faX} className='icon-remove btn-danger' />
        </div>
    </div>
)

export default ContainerImagen